import type { ReactNode } from 'react';

export const symbol_egg_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M640-80q-67 0-101.5-22.5T480-150q-19-20-36.5-35T399-200q-45 0-100-15.5t-103.5-51Q147-302 114-359T80-499q-2-167 82.5-274T399-880q71 0 120 20.5t84.5 51.5q35.5 31 60 68.5T710-667q12 20 24 36.5t26 30.5q60 60 90 105t30 136q0 120-74.5 199.5T640-80Zm-.37-60q65.37 0 122.87-62.5T820-358.92q0-72.08-20.5-105.58T718-558q-20-20-36-43t-32-49q-43-69-92.58-119.5Q507.85-820 399-820q-136 0-197.5 96T140-505q0 73 30.5 120.5t72 75.5q41.5 28 85.31 38.5T399-260q45.25 0 72.75 22.4Q499.26-215.2 517-196q24 26 47.51 41 23.51 15 75.12 15ZM480.2-360q49.8 0 84.8-35.2t35-85q0-49.8-35.2-84.8t-85-35q-49.8 0-84.8 35.2t-35 85q0 49.8 35.2 84.8t85 35Zm-.2-120Z"
		/>
	</svg>
);
